<template>
  <div 
    id="provider-list"  
    class="grid-x grid-padding-x">
    <div
      v-for="(provider, index) in providers" 
      :key="index"
      class="small-12 medium-4">
        <provider-card 
          :provider="provider" 
          @show-detail="showDetail(provider)">
        </provider-card>
    </div>
  </div>
</template>

<script>
import ProviderCard from '@/ProviderCard.vue'
import ProviderDetail from '@/ProviderDetail.vue'

export default {
  name: 'ProviderList',
  props: {
    providers: {
      type: Array,
      required: true
    }
  },
  components: {
    ProviderCard
  },
  data () {
    return {
      defaultModalWidth: 900,
      defaultModalHeight: 500
    }
  },
  methods: {
    /** 
     * Show provider detail in modal window
     */
    showDetail (provider) {
      let options = {
        name: 'modal-provider-detail-' + provider.id,
        width: this.modalSize.width,
        height: this.modalSize.height
      }

      let elem = document.querySelector('body')
      if (elem) {
        elem.classList.add('no-scroll')
      }
      
      this.$modal.show(
        ProviderDetail, 
        { 
          provider: provider,
          height: options.height
        }, 
        options
      )
    },
    /** 
     * Load more providers on scroll to bottom
     */
    onScroll () {
      let elem = document.querySelector('html')
      if ((elem.scrollTop + elem.clientHeight) > (elem.scrollHeight - 200)) {
        this.$emit('load-more')
      }
    }
  },
  computed: {
    modalSize () {
      const vp = this.$util.getViewport()
      if (window.matchMedia('(max-width: 640px)').matches) {
        return {
          width: vp.width - 10,
          height: vp.height - 10
        }
      } else {
        return {
          width: this.defaultModalWidth,
          height: this.defaultModalHeight
        }
      }
    }
  },
  mounted () {
    window.addEventListener('scroll', this.onScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll);
  }
}
</script>
